import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900",
      "persistent": ""
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog && !_vm.editedItem.type ? _c('niota-classic-originators-type-selector', {
    attrs: {
      "editedItem": _vm.editedItem
    },
    on: {
      "close": _vm.closeForm,
      "type-selected": _vm.selectedType
    }
  }) : _vm._e(), _vm.formDialog && _vm.editedItem.type ? _c('niota-classic-originators-form', {
    attrs: {
      "editedItem": _vm.editedItem
    },
    on: {
      "close": _vm.closeForm,
      "reset-type": _vm.resetType
    }
  }) : _vm._e()], 1), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.Originators.title'),
      "subtitle": _vm.$i18n_t('NiotaClassic.Originators.subtitle'),
      "buttons": _vm.buttons
    },
    on: {
      "addItem": _vm.addItem
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [_c('niota-classic-originators-list', {
    ref: "list",
    on: {
      "edit-item": _vm.editItem
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };